/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function NotePencil(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M223.99414,120v88a16.01833,16.01833,0,0,1-16,16h-160a16.01833,16.01833,0,0,1-16-16V48a16.01833,16.01833,0,0,1,16-16h88a8,8,0,0,1,0,16h-88V208h160V120a8,8,0,0,1,16,0Zm5.65723-50.34326-96,96A8.00076,8.00076,0,0,1,127.99414,168h-32a8.00039,8.00039,0,0,1-8-8V128a8.00035,8.00035,0,0,1,2.34277-5.65674l96-96a8.00034,8.00034,0,0,1,11.31446,0l32,32A8,8,0,0,1,229.65137,69.65674ZM212.68066,64,191.99414,43.31348,179.30811,56l20.68628,20.68652Z" />
    </Svg>
  );
}

export default NotePencil;
